"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "records-list-component"
  }, [_c("b-table", {
    attrs: {
      data: _vm.punchs,
      loading: _vm.isLoading,
      striped: true,
      hoverable: true,
      "mobile-cards": true
    }
  }, [_c("b-table-column", {
    attrs: {
      field: "photo",
      label: "Foto"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("img", {
          staticClass: "photo",
          attrs: {
            src: props.row.imagePreview,
            alt: "Foto"
          }
        })];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "name",
      label: "Funcionário"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.user.firstName) + " " + _vm._s(props.row.user.lastName) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "cpf",
      label: "CPF / CNPJ"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.user.cpf) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "email",
      label: "Email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.user.email) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "date",
      label: "Data"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatTime(props.row.date)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      label: "Ações"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("b-dropdown", {
          attrs: {
            position: "is-bottom-left"
          }
        }, [_c("b-button", {
          staticClass: "is-text",
          attrs: {
            slot: "trigger",
            "icon-right": "dots-vertical"
          },
          slot: "trigger"
        }), _vm._v(" "), _c("b-dropdown-item", {
          on: {
            click: function click($event) {
              return _vm.$emit("action", "edit", props.row);
            }
          }
        }, [_vm._v("\n          Editar\n        ")]), _vm._v(" "), _c("b-dropdown-item", {
          on: {
            click: function click($event) {
              return _vm.$emit("action", "info", props.row);
            }
          }
        }, [_vm._v("\n          Sobre\n        ")])], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;